enum AccountRoleName {
  OWNER = 'OWNER',
  CO_BORROWER = 'CO_BORROWER',
  THIRD_PARTY_USER = 'THIRD_PARTY_USER',
  THIRD_PARTY_RECIPIENT = 'THIRD_PARTY_RECIPIENT',
  LANDLORD = 'LANDLORD',
  GUARANTOR = 'GUARANTOR',
  GUARDIAN = 'GUARDIAN',
  ASSISTANT_GUARDIAN = 'ASSISTANT_GUARDIAN',
}

export default AccountRoleName;
